import { routeDefinitions, type RouteRecordRaw } from '@gat-ship/lib/router'

export function createAccessControlRoutes(
  startPath: string
): readonly RouteRecordRaw[] {
  return [
    {
      path: startPath,
      component: () => import('../layouts/access-control-root.vue'),
      children: [
        {
          path: '',
          name: routeDefinitions.administration.accessControl.accessRolesList,
          component: () => import('../views/view-access-roles.vue')
        },
        {
          path: ':roleId',
          name: routeDefinitions.administration.accessControl.accessRole
            .permissions,
          props: true,
          component: () => import('../views/view-access-role-permissions.vue')
        }
      ]
    }
  ]
}
